import {useCallback, useEffect, useRef, useState} from 'react';

const TIMEOUT_MS = 10 * 60 * 1000;

export const useInactivityTimeout = (): {
  isInactive: boolean;
  resume: () => void;
} => {
  const [isInactive, setIsInactive] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const startTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setIsInactive(true);
    }, TIMEOUT_MS);
  }, []);

  const resume = useCallback(() => {
    setIsInactive(false);
    startTimer();
  }, [startTimer]);

  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [startTimer]);

  return {isInactive, resume};
};
